"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enablePolkadotSnap = exports.isMetamaskSnapsSupported = exports.isPolkadotSnapInstalled = exports.hasMetaMask = void 0;
require("@polkadot/types-augment");
const snap_1 = require("./snap");
const utils_1 = require("./utils");
const defaultSnapOrigin = 'npm:@chainsafe/polkadot-snap';
__exportStar(require("./extension"), exports);
var utils_2 = require("./utils");
Object.defineProperty(exports, "hasMetaMask", { enumerable: true, get: function () { return utils_2.hasMetaMask; } });
Object.defineProperty(exports, "isPolkadotSnapInstalled", { enumerable: true, get: function () { return utils_2.isPolkadotSnapInstalled; } });
Object.defineProperty(exports, "isMetamaskSnapsSupported", { enumerable: true, get: function () { return utils_2.isMetamaskSnapsSupported; } });
function enablePolkadotSnap(config = { networkName: 'westend' }, snapOrigin, snapInstallationParams = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const snapId = snapOrigin !== null && snapOrigin !== void 0 ? snapOrigin : defaultSnapOrigin;
        // check all conditions
        if (!(0, utils_1.hasMetaMask)()) {
            throw new Error('Metamask is not installed');
        }
        if (!(yield (0, utils_1.isMetamaskSnapsSupported)())) {
            throw new Error("Current Metamask version doesn't support snaps");
        }
        if (!config.networkName) {
            config.networkName = 'westend';
        }
        const isInstalled = yield (0, utils_1.isPolkadotSnapInstalled)(snapId);
        console.info('isInstalled', isInstalled);
        if (!isInstalled) {
            // // enable snap
            yield window.ethereum.request({
                method: 'wallet_requestSnaps',
                params: {
                    [snapId]: Object.assign({}, snapInstallationParams)
                }
            });
        }
        // create snap describer
        const snap = new snap_1.MetamaskPolkadotSnap(snapOrigin || defaultSnapOrigin, config);
        // set initial configuration
        try {
            const snapApi = snap.getMetamaskSnapApi();
            console.info('snapApi', snapApi);
            yield snapApi.setConfiguration(config);
        }
        catch (err) {
            console.error('Failed to set configuration', err);
        }
        return snap;
    });
}
exports.enablePolkadotSnap = enablePolkadotSnap;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxtQ0FBaUM7QUFFakMsaUNBQThDO0FBQzlDLG1DQUF5RjtBQUV6RixNQUFNLGlCQUFpQixHQUFHLDhCQUE4QixDQUFDO0FBSXpELDhDQUE0QjtBQUM1QixpQ0FBeUY7QUFBaEYsb0dBQUEsV0FBVyxPQUFBO0FBQUUsZ0hBQUEsdUJBQXVCLE9BQUE7QUFBRSxpSEFBQSx3QkFBd0IsT0FBQTtBQUV2RSxTQUFzQixrQkFBa0IsQ0FDdEMsU0FBcUIsRUFBRSxXQUFXLEVBQUUsU0FBUyxFQUFFLEVBQy9DLFVBQW1CLEVBQ25CLHlCQUFzRSxFQUFFOztRQUV4RSxNQUFNLE1BQU0sR0FBRyxVQUFVLGFBQVYsVUFBVSxjQUFWLFVBQVUsR0FBSSxpQkFBaUIsQ0FBQztRQUUvQyx1QkFBdUI7UUFDdkIsSUFBSSxDQUFDLElBQUEsbUJBQVcsR0FBRSxFQUFFO1lBQ2xCLE1BQU0sSUFBSSxLQUFLLENBQUMsMkJBQTJCLENBQUMsQ0FBQztTQUM5QztRQUNELElBQUksQ0FBQyxDQUFDLE1BQU0sSUFBQSxnQ0FBd0IsR0FBRSxDQUFDLEVBQUU7WUFDdkMsTUFBTSxJQUFJLEtBQUssQ0FBQyxnREFBZ0QsQ0FBQyxDQUFDO1NBQ25FO1FBQ0QsSUFBSSxDQUFDLE1BQU0sQ0FBQyxXQUFXLEVBQUU7WUFDdkIsTUFBTSxDQUFDLFdBQVcsR0FBRyxTQUFTLENBQUM7U0FDaEM7UUFFRCxNQUFNLFdBQVcsR0FBRyxNQUFNLElBQUEsK0JBQXVCLEVBQUMsTUFBTSxDQUFDLENBQUM7UUFDMUQsT0FBTyxDQUFDLElBQUksQ0FBQyxhQUFhLEVBQUUsV0FBVyxDQUFDLENBQUM7UUFFekMsSUFBSSxDQUFDLFdBQVcsRUFBRTtZQUNoQixpQkFBaUI7WUFDakIsTUFBTSxNQUFNLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQztnQkFDNUIsTUFBTSxFQUFFLHFCQUFxQjtnQkFDN0IsTUFBTSxFQUFFO29CQUNOLENBQUMsTUFBTSxDQUFDLG9CQUFPLHNCQUFzQixDQUFFO2lCQUN4QzthQUNGLENBQUMsQ0FBQztTQUNKO1FBRUQsd0JBQXdCO1FBQ3hCLE1BQU0sSUFBSSxHQUFHLElBQUksMkJBQW9CLENBQUMsVUFBVSxJQUFJLGlCQUFpQixFQUFFLE1BQU0sQ0FBQyxDQUFDO1FBQy9FLDRCQUE0QjtRQUU1QixJQUFJO1lBQ0YsTUFBTSxPQUFPLEdBQUcsSUFBSSxDQUFDLGtCQUFrQixFQUFFLENBQUM7WUFDMUMsT0FBTyxDQUFDLElBQUksQ0FBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFDakMsTUFBTSxPQUFPLENBQUMsZ0JBQWdCLENBQUMsTUFBTSxDQUFDLENBQUM7U0FDeEM7UUFBQyxPQUFPLEdBQUcsRUFBRTtZQUNaLE9BQU8sQ0FBQyxLQUFLLENBQUMsNkJBQTZCLEVBQUUsR0FBRyxDQUFDLENBQUM7U0FDbkQ7UUFFRCxPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7Q0FBQTtBQTVDRCxnREE0Q0MifQ==